export enum MarkdownVariant {
    BORDERLESS = 'BORDERLESS',
    INFO = 'INFO',
    WARNING = 'WARNING',
    TIP = 'TIP',
}
